import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export class AddReasonForDelayRequest {
  caseActionSk: string;
  reasonForDelayId: number;
  stageId: number;
  description: string;
  isActive: boolean;

  constructor(data: any, referenceData: Record<string, IReferenceData[]>) {
    this.caseActionSk = data?.referralSk;
    this.reasonForDelayId = data?.reasonForDelay?.id;
    this.stageId = 1;
    this.description = data?.description;
    this.isActive = data.isActive;
  }

  get id(): string {
    return '';
  }
}
